import { Store, useStore } from 'dg-web-shared/lib/Flux.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';
import { Translation } from '../../common/i18n/Text.ts';
import * as PermitTypeState from '../../common/state/PermitTypeState.ts';
import {
    NumberMultiSelectionSlideIn,
    Option,
} from '../../ui/slidein/MultiSelectionSlideIn.tsx';
import * as CustomerClearanceTexts from '../i18n/CustomerClearanceTexts.ts';
import * as CustomerClearanceState from '../state/CustomerClearanceState.ts';

export interface PermitTypeSelectionTexts {
    slideInHeader: Translation;
}

export const setPermitTypes = (s: Store, pt: number[]): string => {
    CustomerClearanceState.Add.stateWrite(s, {
        permitTypeIds: pt,
    });
    return 'PermitTypeFilterSlideInsetPermitTypes';
};

export function PermitTypeSelectionSlideIn() {
    const { storeState, update } = useStore(store => ({
        permitTypes: PermitTypeState.get(store),
        add: CustomerClearanceState.Add.get(store),
    }));
    const { language } = useLanguage();

    const options: Option<number>[] = storeState.permitTypes.data
        .filter(pt => pt.isWhitelistCustomer && pt.operatorState == 'ACTIVE')
        .map(pt => {
            return {
                id: pt.id,
                displayText: pt.description,
            };
        });

    return (
        <NumberMultiSelectionSlideIn
            open={!!storeState.add.permitTypeSelectionOpen}
            heading={CustomerClearanceTexts.permitTypeSelectionTexts[
                language
            ].slideInHeader()}
            selection={storeState.add.permitTypeIds || []}
            options={options}
            onLeftActionClick={() =>
                update(store =>
                    CustomerClearanceState.Add.stateWrite(store, {
                        permitTypeSelectionOpen: false,
                    }),
                )
            }
            setNewSelection={v => update(store => setPermitTypes(store, v))}
        />
    );
}
